var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"h-4 w-4",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M3 11.614v.772a2 2 0 0 0 2 2h2l7 7V2l-7 7H5a2 2 0 0 0-2 2Z"}}),_c('path',{attrs:{"d":"M15.5 12a4.5 4.5 0 0 1 0-6"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }